import {
  GetProps,
  SizableText,
  styled,
  H1 as TMH1,
  H2 as TMH2,
  H3 as TMH3,
  H4 as TMH4,
  H5 as TMH5,
  H6 as TMH6,
  Heading as TMHeading,
  Paragraph as TMParagraph
} from 'tamagui';

export const Paragraph = styled(TMParagraph, {});
export const Text = styled(SizableText, {});

export const Heading = styled(TMHeading, {
  color: '$headingFont',
  userSelect: 'none',

  variants: {
    sheet: {
      true: {
        render: 'h4',
        size: '$8',
        fontWeight: '$7',
        flexGrow: 1,
        flexShrink: 1
      }
    },

    active: {
      true: {
        color: '$unistocks',
        fontWeight: '$7'
      }
    }
  } as const
});

export const H1 = styled(TMH1, {
  color: '$headingFont',
  userSelect: 'none'
});
export const H2 = styled(TMH2, {
  color: '$headingFont',
  userSelect: 'none'
});
export const H3 = styled(TMH3, {
  color: '$headingFont',
  userSelect: 'none'
});
export const H4 = styled(TMH4, {
  color: '$headingFont',
  userSelect: 'none'
});
export const H5 = styled(TMH5, {
  color: '$headingFont',
  userSelect: 'none'
});
export const H6 = styled(TMH6, {
  color: '$headingFont',
  userSelect: 'none'
});

export type HeadingProps = GetProps<typeof Heading>;
export type ParagraphProps = GetProps<typeof Paragraph>;
export type TextProps = GetProps<typeof Text>;
